function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2560 217.65H469.29c-6.444 0-44.651 92.677-50.942 92.677s1.841-297.826-4.6-297.826-48.182 203.46-54.014 203.46H0",
  fill: "none",
  stroke: "rgba(9,191,255,0.6)",
  strokeMiterlimit: 10,
  strokeWidth: 25,
  opacity: 0.13
});

function SvgPulseLine1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2560,
    height: 322.826,
    viewBox: "0 0 2560 322.826"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYwIiBoZWlnaHQ9IjMyMi44MjYiIHZpZXdCb3g9IjAgMCAyNTYwIDMyMi44MjYiPjxwYXRoIGQ9Ik0yODc4LjgzNCw3MTUuNEg3ODguMTI0Yy02LjQ0NCwwLTQ0LjY1MSw5Mi42NzctNTAuOTQyLDkyLjY3N3MxLjg0MS0yOTcuODI2LTQuNi0yOTcuODI2UzY4NC40LDcxMy43MTEsNjc4LjU2OCw3MTMuNzExSDMxOC44MzQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMTguODM0IC00OTcuNzUpIiBmaWxsPSJub25lIiBzdHJva2U9InJnYmEoOSwxOTEsMjU1LDAuNikiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyNSIgb3BhY2l0eT0iMC4xMyIvPjwvc3ZnPg==";
export { SvgPulseLine1 as ReactComponent };